export * from './product-item-inline.module'
export * from './product-item-inline.component'
